import { render, staticRenderFns } from "./DialogBox.vue?vue&type=template&id=6ecc73b8&scoped=true&"
import script from "./DialogBox.vue?vue&type=script&lang=js&"
export * from "./DialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecc73b8",
  null
  
)

export default component.exports